import React, { useRef, useState } from 'react';
import { Alert, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import ButtonLoading from "../../../../components/Button/ButtonLoading";
import { usePostAnchantoReserve } from "../../../../reusables/hooks/post/usePostAnchantoReserve";
import { InStoreTab } from "./InStoreTab";

export function OnlineTab({ openModalProduct, pathname, history }) {
    const [marketplaceOrderId, setMarketplaceOrderId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [status, setStatus] = useState('idle');
    const { isFetch, postAnchantoReserve } = usePostAnchantoReserve();
    const isSubmittingRef = useRef(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (isSubmittingRef.current || isFetch) return;

        setErrorMessage('');
        isSubmittingRef.current = true;
        postAnchantoReserve({ marketplace_order_id: marketplaceOrderId.trim() })
            .then(() => setStatus('reserved'))
            .catch((err) => setErrorMessage(err?.error?.message || 'Something went wrong, please try again later.'))
            .finally(() => { isSubmittingRef.current = false; });
    };

    if (status === 'completed') {
        return (
            <Alert color="success">
                Payment has been created for the reserved order. Manual process is completed.
            </Alert>
        );
    }

    if (status === 'reserved') {
        return (
            <div>
                <Alert color="success">
                    Order is reserved, please proceed manually.
                </Alert>
                <InStoreTab
                    openModalProduct={openModalProduct}
                    pathname={pathname}
                    history={history}
                    onPaymentCompleted={() => setStatus('completed')}
                />
            </div>
        );
    }

    return (
        <div>
            {errorMessage && (
                <Alert color="danger">
                    {errorMessage}
                </Alert>
            )}
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>Marketplace Order ID*</Label>
                            <Input
                                name="marketplaceOrderId"
                                value={marketplaceOrderId}
                                placeholder="Enter Marketplace Order ID"
                                onChange={(e) => setMarketplaceOrderId(e.target.value)}
                                disabled={isFetch}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <p className={'required-remark'}>(*) this field is required.</p>
                <ButtonLoading
                    type="submit"
                    isLoading={isFetch}
                    disabled={isFetch || !marketplaceOrderId.trim()}
                    loadingMessage="Submitting..."
                    color="primary"
                >
                    Submit
                </ButtonLoading>
            </Form>
        </div>
    );
}
